import { SxProps } from "@mui/material";
import { ArrowDownward, ArrowUpward, } from "@mui/icons-material";
import { formatPercent } from "@arelia-utils/helpers/formatCurrency";
import CardStatus from "./CardStatus";

interface ChangeCardStatusProps {
  change: number;
  timespan?: string;
  sx?: SxProps;
}

export function ChangeCardStatus({ change, timespan, sx }: ChangeCardStatusProps) {
  const iconSX: SxProps = { width: 18, height: 18, mr: 1 };

  const statusColor = change > 0 ? "success" : change === 0 ? "warning" : "error";

  const statusIcons = {
    "success": <ArrowUpward color="success" sx={iconSX} />,
    "error": <ArrowDownward color="error" sx={iconSX} />,
    "warning": ""
  };

  return (
    timespan ?
      <CardStatus color={`${statusColor}.main`} sx={sx}>
        {statusIcons[statusColor]}
        {change !== 0 ? `${formatPercent(change)}% from last ${timespan}` : "no changes"}
      </CardStatus>
      : <></>
  );
}